<div class="custom-field" [id]="field?.fieldColumn">
	<div class="skills-selection-container" fxLayout="column" fxLayoutAlign="start start">
		<div fxLayout="row" fxLayoutAlign="start start">
			<mat-label [ngClass]="{error: (control.errors && control.touched)}"
				*ngIf="![null, undefined, ''].includes(field.fieldCaption) && field?.additionalMetaData?.showLabel">
				{{field.fieldCaption}} <span *ngIf="field?.isRequired">*</span></mat-label>
			<ng-container *ngIf="field?.helpLine?.length">
				<app-help-line [helpLineData]="field.helpLine" fxLayout="row" fxLayoutAlign="start start"
					(helpLineEmit)="helpLineData($event)"></app-help-line>
			</ng-container>
		</div>

		<ng-container *ngIf="!showSkill">
			<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
				<p> {{ field?.options?.caption }} </p>
				<div fxLayout="row wrap" fxLayoutAlign="start start">
					<ng-container *ngFor="let skillData of field?.options?.data; let i = index;">
						<app-chips class="parent-chip cursor-pointer" [ngClass]="{'selected': skillData?.selected}"
							[data]="{title: skillData?.value}" (chipInfo)="showSkills(skillData, i)"
							[background]="(skillData?.selected) ? '#0091ea' : null" [color]="(skillData?.selected) ? 'white' : null"
							[removable]="false" type="standard">
						</app-chips>
					</ng-container>
				</div>
			</div>

		</ng-container>

		<ng-container *ngIf="showSkill">
			<div fxLayout="column" fxLayoutAlign="start start">
				<p fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
					<mat-icon class="back-to-parent" (click)="showCompetencies()">arrow_back</mat-icon>
					<span>{{ field?.options?.data[selectedIndex]?.childData?.caption || currentCompetencyName }}</span>
				</p>
				<div fxLayout="row wrap" fxLayoutAlign="start start">
					<ng-container *ngIf="field?.additionalMetaData?.selectionType === 'weightage'">
						<ng-container *ngFor="let skill of field?.options?.data[selectedIndex]?.childData?.data">
							<app-weightage class="weightage" [field]="skill?.field" [formControl]="skill?.control"
								[control]="skill?.control"
								(weightageTriggered)="weightageTriggered(field?.options?.data[selectedIndex], skill)">
							</app-weightage>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="field?.additionalMetaData?.selectionType === 'standard'">
						<ng-container
							*ngFor="let skill of field?.options?.data[selectedIndex]?.childData?.data; let skillIndex = index;">
							<app-chips class="parent-chip cursor-pointer" [ngClass]="{'selected': skill?.selected}"
								[data]="{title: skill?.value}" (chipInfo)="selectSkills(skill, skillIndex)"
								[background]="(skill?.selected) ? '#0091ea' : null" [color]="(skill?.selected) ? 'white' : null"
								[removable]="false" type="standard">
							</app-chips>
						</ng-container>
					</ng-container>

				</div>
			</div>

		</ng-container>

		<mat-hint *ngIf="(control?.untouched || control?.valid) && ![null, undefined, ''].includes(field?.fieldHelpText)">
			{{field?.fieldHelpText}}</mat-hint>
		<mat-error *ngIf="control?.errors && control?.touched" [innerHtml]="controlFunctions.validationMsg(control, field)">
		</mat-error>
	</div>

</div>
